import type { LoadableType } from '@confluence/loadable';
import { LoadableBackground } from '@confluence/loadable';
import type { CoreInvitesWithFlagsProps } from './CoreInvites.tsx';

export const CoreInvitesLoadable: LoadableType<Omit<CoreInvitesWithFlagsProps, 'flags'>> =
	LoadableBackground({
		loader: async () =>
			(await import(/* webpackChunkName: "loadable-CoreInvites" */ './CoreInvites.tsx'))
				.CoreInvites,
	});
